import { useState, useEffect } from 'react';
import { useAuthFetch } from '../../hooks/useAuthFetch';

export default function ActivityTab() {
  const { authFetch } = useAuthFetch();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    authFetch(`${process.env.REACT_APP_API_URL}/api/admin/activity`)
      .then(res => res.json())
      .then(data => { setRows(data); setLoading(false); })
      .catch(err => { console.error(err); setError('Failed to load activity.'); setLoading(false); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <p className="costs-loading">Loading activity…</p>;
  if (error) return <p className="costs-error">{error}</p>;
  if (rows.length === 0) return <p className="costs-empty">No user activity yet.</p>;

  return (
    <div className="costs-section">
      <div className="costs-section-title">Recent User Activity</div>
      <p className="costs-note">
        Result and Confidence are <strong>self-reported by the client</strong>, not server-verified.
        The study app holds the answer key in order to grade free-text answers, so a user can submit
        any result for their own questions. Treat these columns as study signal, not as an audit trail.
      </p>
      <div className="costs-table-wrapper">
        <table className="costs-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Topic</th>
              <th>Question</th>
              <th>Answer</th>
              <th title="Self-reported by the client — not server-verified">Result *</th>
              <th title="Self-reported by the client — not server-verified">Confidence *</th>
              <th>When</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.id}>
                <td style={{ whiteSpace: 'nowrap' }}>{row.display_name || `User #${row.id}`}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{row.topic_name}</td>
                <td style={{ maxWidth: '220px' }}>{row.question_text}</td>
                <td style={{ maxWidth: '220px' }}>{row.selected_answer}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <span style={{
                    padding: '2px 8px',
                    borderRadius: '999px',
                    fontSize: '0.78rem',
                    fontWeight: 500,
                    background: row.is_correct ? 'var(--color-accent-bg-2)' : 'rgba(239,68,68,0.12)',
                    color: row.is_correct ? 'var(--color-text)' : 'rgb(239,68,68)',
                  }}>
                    {row.is_correct ? 'Correct' : 'Incorrect'}
                  </span>
                </td>
                <td style={{ textAlign: 'center' }}>{row.confidence ?? '—'}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {new Date(row.answered_at).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
